<template>
  <div class="details">
    <div class="details_add">
      <div class="add_item">
        <span class="item_title">书籍归属</span>
        <span class="item_non">{{ drawerItem.book_name }}</span>
      </div>
      <div class="add_item">
        <span class="item_title">小说</span>
        <el-autocomplete
          v-model="novel_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入小说名称"
          :disabled="isP"
          @select="handleSelect"
        />
      </div>
      <el-button type="primary" style="margin-left: 310px" @click="addPitcher">绑定</el-button>
    </div>
    <div class="details_contentArea">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        max-height="300"
        border
        style="width: 80%; margin:0 auto;"
      >
        <el-table-column
          prop="id"
          label="id"
        />
        <el-table-column
          prop="novel_name"
          label="小说名"
        />
        <el-table-column
          prop="novel_id"
          label="小说id"
        />
        <el-table-column
          prop="book_belong_id"
          label="归属"
        />
        <el-table-column
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="deletePitcher(scope.row)">取消绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="tableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

  </div>
</template>

<script>
import { getFictionList, getTitleList, novelsBoundToBooks, deleteNovelsBoundToBooks } from '@/api/releaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      tableData: {},
      parameter: {
        page: 1,
        page_size: 10,
        book_belong_id: this.drawerItem.id
      },
      addParameter: {
        book_belong_id: this.drawerItem.id,
        novel_id: null
      },
      novel_name: null,
      loading: false,
      isP: true
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    setTimeout(() => {
      this.isP = false
    })
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getTitleList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    // 绑定书籍
    async addPitcher() {
      let text = null
      this.addParameter.novel_id || (text = '请选择小说')
      text || await novelsBoundToBooks(this.addParameter)
      text || this.getDataList()
      text || (this.addParameter.novel_id = null)
      this.novel_name = null
      this.$message({
        message: text || '添加成功',
        type: text ? 'warning' : 'success'
      })
    },

    // 删除绑定
    async deletePitcher(row) {
      await deleteNovelsBoundToBooks({ alias_id: row.id })
      this.getDataList()
      this.$message({
        message: '取消绑定成功',
        type: 'success'
      })
    },

    async querySearchAsync(queryString, cb) {
      const data = await getFictionList({ name: queryString || null })
      const newss = data.data.list.map((item) => {
        return {
          value: item.name,
          address: item.id
        }
      })
      cb(newss)
    },
    handleSelect(item) {
      this.addParameter.novel_id = item.address
    }
  }
}
</script>

<style scoped>
.details{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
}

.details_add{
    width: 80%;
    margin: 0 auto;
}

.add_item{
   margin-bottom: 15px;
}

.item_title{
    display: inline-block;
    width: 100px;
}

.item_non{

}

.details_contentArea{
  margin-top: 50px;
}
</style>
